import React, { useContext } from 'react'
import { IntegrationServiceId } from '../../common/integrations'

export interface ContactUpdateHistoryData {
  contactValues: Record<string, unknown>
  contactSchema: Record<string, unknown>
  serviceId: IntegrationServiceId
}

export interface ContactUpdateHistoryContextValue {
  isHistoryMode: boolean
  historyData: ContactUpdateHistoryData | null
  setHistoryData: (data: ContactUpdateHistoryData) => void
  clearHistoryMode: () => void
}

const ContactUpdateHistoryContext = React.createContext<ContactUpdateHistoryContextValue | null>(null)

export const useContactUpdateHistory = (): ContactUpdateHistoryContextValue | null => {
  const context = useContext(ContactUpdateHistoryContext)
  return context
}

export { ContactUpdateHistoryContext }
